import { modelVersions } from '../../services/constants';

const StartExplanation = ({ modelVersion }) => {
    let text;
    if (modelVersion === modelVersions.substraat) {
        text = `Kies gewas, substraat, gewasstadium en EC irrigatie.`;
    }
    if (modelVersion === modelVersions.potplant) {
        text = `Kies een gewas, teeltfase en EC irrigatie.`;
    }
    return <div>&larr; {text}</div>;
};

export default StartExplanation;
